// extracted by mini-css-extract-plugin
module.exports = {"downloadButton":"DownloadAppAccordianContent_downloadButton__2sEBc","windowsButton":"DownloadAppAccordianContent_windowsButton__1mmRq"};